import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
import Button from '../../../components/uiKit/Button'
import ReCaptchaField from '../ReCaptchaField'



const required = value => value ? undefined : 'Sorry but we are going to need you to tell us that'
const email = value =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9.-]/i.test(value) ?
		'Are you sure thats an email?' : undefined

class EditUserEmailForm extends React.Component{

	render(){

		return(			
				<form onSubmit={this.props.handleSubmit} >				    				    			          
				
					<Field 
		        		name='email'
		        		type='text'
		        		label='New Email'
				        component={FormFieldText}
				        placeholder='email@example.com'				          	
				        validate={[required, email]}
				        autoComplete='false'
				        autoFocus={true}
				    />

				    <Field 
		        		name='currentPassword'
		        		type='password'
		        		label='Password'
				        component={FormFieldText}
				        placeholder='Your current password'
				        validate={[required]}
				        autoComplete='false'
				    />

				 	<div className='accountForm-actionRow'>							        			
	        	<Button 
	        		size='xLarge'
	        		submitLoading={this.props.submitLoading}
	        		label='Update Email'
	        		color={this.props.dirty && this.props.valid ? 'blue' : 'gray'}
	        		canSubmit={this.props.dirty && this.props.valid && !this.props.submitLoading ? true : false}
	        		type='submit'
	        	/>
	        </div>

	        <Field name='recaptchaResponse' component={ReCaptchaField}/> 
	     	</form>			 
		)
	}
}



const mapStateToProps = (state,ownProps) => {
	return {
		initialValues: {
			email:ownProps.email,
		}
	}
}

EditUserEmailForm = reduxForm({
	form: 'editUserEmailForm',
	enableReinitialize: true,
	autoComplete:'off'
})(EditUserEmailForm)

export default connect(mapStateToProps)(EditUserEmailForm)






// WEBPACK FOOTER //
// ./src/components/forms/account/EditUserEmailForm.js